import ls from 'local-storage';

import { APP_UPDATE_HEADER_NAME } from './constants';

export default class ClientStorage {

  static getPersistedState() {
    try {
      const serializedState = ls.get('state');
      if (serializedState === null) {
        return null;
      }
      return JSON.parse(serializedState);
    } catch (err) {
      return undefined;
    }
  }

  static setPersistedState(store) {
    try {
      const filteredState = this.getFilteredState(store.getState());
      const serializedState = JSON.stringify(filteredState);
//      sessionStorage.setItem('state', serializedState);
    } catch (err) {
      // Ignore write errors.
    }
  }

  static getFilteredState(state) {
    const { groups, resources, units } = state;
    return {
      session: {
        ...state.session,
        loginFailed: false,
        sessionCleared: false
      },
      booking: {
        selectedOptionIds: state.booking.selectedOptionIds,
        additionalDiscussionChecked: state.booking.additionalDiscussionChecked
      },
      groups,
      resources,
      units
    };
  }

  static clearState() {
    try {
      sessionStorage.clear();
      console.log('Local store cleared successfully.');
    } catch (err) {
      // for now we do not do anything here
      console.log('Local store was not cleared successfully.');
    }
  }

  static setAppBuildTimestamp(appBuildTimestamp) {
    sessionStorage.setItem(APP_UPDATE_HEADER_NAME, appBuildTimestamp);
  }

  static getAppBuildTimestamp() {
    return sessionStorage.getItem(APP_UPDATE_HEADER_NAME);
  }

  static removeAppBuildTimestamp() {
    sessionStorage.removeItem(APP_UPDATE_HEADER_NAME);
  }

  static setAppUpdateInProgress() {
    sessionStorage.setItem('UpdateInProgress', '1');
  }

  static isAppUpdateInProgress() {
    return sessionStorage.getItem('UpdateInProgress');
  }

  static clearAppUpdateInProgress() {
    sessionStorage.removeItem('UpdateInProgress');
  }

}



// WEBPACK FOOTER //
// ./src/util/ClientStorage.js